function insertChipAtCaret(element: HTMLElement, token: string): void {
  element.focus();
  const sel = globalThis.getSelection?.();
  if (!sel || sel.rangeCount === 0) return;

  const range = sel.getRangeAt(0);

  const span = document.createElement('span');
  span.contentEditable = 'false';
  span.className = 'slot-chip slot-chip-clean';
  span.textContent = token;
  const slotName = token.slice(1, -1);
  span.dataset.slotName = slotName;
  range.insertNode(span);

  range.setStartAfter(span);
  range.collapse(true);

  let insertSpace = true;
  if (range.startContainer.nodeType === Node.TEXT_NODE) {
    const text = range.startContainer.textContent || '';
    if (text.startsWith(' ')) {
      insertSpace = false;
    }
  }
  if (insertSpace) {
    const spaceNode = document.createTextNode(' ');
    range.insertNode(spaceNode);
    range.setStartAfter(spaceNode);
    range.collapse(true);
  }

  sel.removeAllRanges();
  sel.addRange(range);
}

export default insertChipAtCaret;
